module.exports = __webpack_public_path__ + "static/media/ru.4b396616.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/ru.svg
// module id = 1467
// module chunks = 0